import { type TripRead } from 'src/common/external/bambi-api/tripsApi.generated';

export function shouldSeparateCancelReasonValueAndLabel(trip?: TripRead) {
  /**
   * Return true when cancellation should pass the reason value and label
   * separately.
   */
  const intermediaries = ['modivcare', 'medidrive'];

  if (!trip?.id) {
    return false;
  }

  return intermediaries.includes(trip.intermediary ?? '');
}

export function shouldSeparateRejectReasonValueAndLabel(trip?: TripRead) {
  /**
   * Return true when rejection should pass the reason value and label
   * separately.
   */
  const intermediaries = ['modivcare'];

  if (!trip?.id) {
    return false;
  }

  return intermediaries.includes(trip.intermediary ?? '');
}
